import { LANGS } from './strings';
import { useI18n } from './context';

// LangToggle from the design system: EN / FI / SV segmented switch. Each
// button names its language in that language and is marked with its own
// lang attribute so screen readers pronounce it correctly.
export function LangToggle() {
  const { lang, setLang, t } = useI18n();
  return (
    <div className="lang" role="group" aria-label={t['lang.label']}>
      {LANGS.map((l) => (
        <button
          key={l.code}
          type="button"
          lang={l.code}
          aria-label={l.name}
          aria-pressed={lang === l.code}
          className={lang === l.code ? 'on' : undefined}
          onClick={() => setLang(l.code)}
        >
          {l.code.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
